import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, OFFER_ANCHOR, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-brand-navy text-white" data-id="element-52" data-mp="c4fw0l6gszqt">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-53" data-mp="83vy3fe2hs3m">
        <p className="text-[0.65rem] font-extrabold uppercase tracking-[0.16em] text-brand-yellow" data-id="element-54" data-mp="m3x0iz9zd7l7">
          Una última oportunidad
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-snug text-white/85" data-id="element-55" data-mp="h413jjzpagf5">
          Puedes seguir guardando videos sobre PLC, Ladder, sensores y
          automatización sin saber qué deberías aprender primero. O puedes
          comenzar hoy a construir una nueva habilidad siguiendo una ruta
          organizada desde cero.
        </p>
        <h2 id="cierre" className="mt-1.5 font-display text-xl uppercase leading-tight text-white sm:text-3xl" data-id="element-56" data-mp="zxekgl6kwmbr">
          No necesitas ser experto en automatización para empezar. Necesitas{' '}
          <span className="text-brand-yellow" data-id="element-57" data-mp="2h3zs05np4cns">dar el primer paso.</span>
        </h2>

        <Reveal className="mt-3 rounded-xl border-4 border-brand-yellow bg-white p-4 text-brand-carbon" data-id="element-58" data-mp="2m19f3enm4c8g">
          <p className="text-[0.8rem] font-extrabold uppercase leading-tight text-brand-blue sm:text-sm" data-id="element-59" data-mp="2r3iaehnyjqdq">
            {PRODUCT_NAME}
          </p>
          <p className="mt-0.5 text-[0.75rem] font-extrabold uppercase text-brand-carbon" data-id="element-60" data-mp="302c5u4pjyapp">
            6 Tomos + 5 Bonos
          </p>
          <p className="mt-1 text-[0.75rem] text-brand-muted" data-id="element-61" data-mp="34un30zswriek">
            Valor de los bonos:{' '}
            <span className="line-through decoration-red-600" data-id="element-62" data-mp="39r3rxw7xm0sp">{BONUS_VALUE}</span>
          </p>
          <p className="mt-1 font-display text-5xl leading-none text-brand-navy sm:text-6xl" data-id="element-63" data-mp="3esjg3x5eonfb">
            Hoy: {PRICE}
          </p>

          <CtaButton href={OFFER_ANCHOR} size="lg" className="mt-3" data-id="element-64" data-mp="3ir0mufkwzvw7">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2.5 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[0.68rem] font-semibold text-brand-muted" data-id="element-65" data-mp="1epief9rzv7bd">
            <span className="flex items-center gap-1" data-id="element-66" data-mp="1shggx1r7a4yk">
              <ZapIcon size={12} className="text-brand-blue" data-id="element-67" data-mp="1nq6uea0y7hqw" />
              Acceso Inmediato
            </span>
            <span data-id="element-68" data-mp="22ebe9hbqlzb9">•</span>
            <span data-id="element-69" data-mp="22djjg8pys5m1">Entrega Digital</span>
            <span data-id="element-70" data-mp="22gnxdxt8efpw">•</span>
            <span className="flex items-center gap-1" data-id="element-71" data-mp="1xg9m86wc2pnn">
              <ShieldCheckIcon size={12} className="text-brand-blue" data-id="element-72" data-mp="1xhuhjyqh2cmk" />
              Garantía de 7 Días
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}